import { useEffect } from 'react';

interface SchemaJsonLdProps {
  schema: Record<string, unknown>;
  id: string;
}

export default function SchemaJsonLd({ schema, id }: SchemaJsonLdProps) {
  useEffect(() => {
    const existing = document.getElementById(id);
    if (existing) existing.remove();

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = id;
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, [id]);

  return null;
}
